import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const MagicEdit = withDefaultIconProps(
  {
    height: 20,
    width: 20,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} fill="none">
      <Path
        d="M12.954 4.468l2.829 2.83m.566-5.091l1.697 1.697a.8.8 0 010 1.13L6.59 16.49l-3.535.707.706-3.535L15.217 2.207a.8.8 0 011.132 0zM2.93.902l-.377 1.507a.2.2 0 01-.144.146L.9 2.931c-.202.05-.202.337 0 .388l1.508.377a.2.2 0 01.146.144l.377 1.508c.05.202.337.202.388 0l.377-1.508a.2.2 0 01.144-.145L5.35 3.32c.202-.05.202-.337 0-.387l-1.508-.377a.2.2 0 01-.145-.146L3.32.903c-.05-.203-.337-.203-.387 0zm14.194 14.223l-.4 1.6-1.6.4 1.6.4.4 1.6.4-1.6 1.6-.4-1.6-.4-.4-1.6z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
    </Svg>
  ),
);
